import request from "../../utils/request";
import { Result } from "../../models/general";

// Face Recognition Settings types

/**
 * Full settings view with audit info (for Operators)
 */
export interface FaceRecognitionSettingsView {
  faceMatchThreshold: number;
  livenessThreshold: number;
  debounceFrames: number;
  recognitionTimeoutSeconds: number;
  globalFaceRecognitionEnabled: boolean;
  requireLivenessCheck: boolean;
  lastModifiedBy: string | null;
  lastModifiedAt: string | null;
}

/**
 * Public settings view without audit info (for ClockDialog)
 */
export interface FaceRecognitionSettingsPublicView {
  faceMatchThreshold: number;
  livenessThreshold: number;
  debounceFrames: number;
  recognitionTimeoutSeconds: number;
  globalFaceRecognitionEnabled: boolean;
  requireLivenessCheck: boolean;
}

/**
 * Input for updating face recognition settings
 */
export interface FaceRecognitionSettingsInput {
  faceMatchThreshold: number;
  livenessThreshold: number;
  debounceFrames: number;
  recognitionTimeoutSeconds: number;
  globalFaceRecognitionEnabled: boolean;
  requireLivenessCheck: boolean;
}

/**
 * Get face recognition settings (Operator only)
 */
export async function getFaceRecognitionSettings() {
  const response = await request.get<Result<FaceRecognitionSettingsView>>("FaceRecognitionSettings");
  return response.data;
}

/**
 * Update face recognition settings (Operator only)
 */
export async function updateFaceRecognitionSettings(input: FaceRecognitionSettingsInput) {
  const response = await request.put<Result<FaceRecognitionSettingsView>>("FaceRecognitionSettings", input);
  return response.data;
}

/**
 * Get public face recognition settings (any authenticated user)
 * Used by ClockDialog and other components
 */
export async function getFaceRecognitionPublicSettings() {
  const response = await request.get<Result<FaceRecognitionSettingsPublicView>>("FaceRecognitionSettings/Public");
  return response.data;
}
